import { 
    GET_SAVED_NEWS_SUCCEEDED, 
    GET_FAVORITE_CINEMAS_SUCCEEDED, 
    GET_YOUR_RETINGS_SUCCEEDED, 
    GET_FAVORITE_MOVIES_SUCCEEDED, 
    GET_UNVIEWED_NOTIFICATION_COUNT_SUCCEEDED, 
    GET_USER_DETAILS_SUCCEEDED, 
    GET_NOTIFICATION_LIST_SUCCEEDED,
    GET_FAVORITE_MOVIES_SEE_MORE_SUCCEEDED,
    GET_FAVORITE_CINEMAS_SEE_MORE_SUCCEEDED,
    GET_SAVED_NEWS_SEE_MORE_SUCCEEDED,
    STORE_FACEBOOK_OR_GOOGLE_RESPONSE_SUCCEEDED} from "../actions/types";


const initalState = {
    savedNews: {},
    favoriteCinemas: {},
    yourRetings: {},
    favoriteMovies: {},
    notificationCount: {},
    userDetails: {},
    notifications: {},
    facebookOrGoogleResponse: {}
}

export default function(state = initalState, action){
    switch(action.type) {
        case GET_SAVED_NEWS_SUCCEEDED:
            return {
                ...state,
                savedNews: action.payload
            }
        case GET_SAVED_NEWS_SEE_MORE_SUCCEEDED:
            return {
                ...state,
                savedNews: action.payload
            }
        case GET_FAVORITE_CINEMAS_SUCCEEDED:
            return {
                ...state,
                favoriteCinemas: action.payload
            }
        case GET_FAVORITE_CINEMAS_SEE_MORE_SUCCEEDED:
            return {
                ...state,
                favoriteCinemas: action.payload
            }
        case GET_YOUR_RETINGS_SUCCEEDED:
            return {
                ...state,
                yourRetings: action.payload
            }
        case GET_FAVORITE_MOVIES_SUCCEEDED:
            return {
                ...state,
                favoriteMovies: action.payload
            }
        case GET_FAVORITE_MOVIES_SEE_MORE_SUCCEEDED:
            return {
                ...state,
                favoriteMovies: action.payload
            }
        case GET_UNVIEWED_NOTIFICATION_COUNT_SUCCEEDED:
            return {
                ...state,
                notificationCount: action.payload
            }
        case GET_USER_DETAILS_SUCCEEDED:
            return {
                ...state,
                userDetails: action.payload
            }
        case GET_NOTIFICATION_LIST_SUCCEEDED:
            return {
                ...state,
                notifications: action.payload
            }
        case STORE_FACEBOOK_OR_GOOGLE_RESPONSE_SUCCEEDED:
            return {
                ...state,
                facebookOrGoogleResponse: action.payload
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/SHARED/reducers/profile.reducer.js